/* eslint-disable react/jsx-props-no-spreading, react/require-default-props */
import React from 'react';
import {
  Option,
  Select,
  Badge,
  Sizes,
} from '@sede-enterprise/shell-ds-react-framework';
import { ISelectProps } from '@sede-enterprise/shell-ds-react-framework/build/esm/components/Select/Select.types';
import { Controller, UseControllerProps } from 'react-hook-form';
import ErrorMessage from '../ErrorMessage';
import {
  IMemoisedComponentProp,
  ISelectOptions,
} from '../../types/Common.type';

interface IFormControlSelect extends IMemoisedComponentProp {
  label: string;
  isLoading: boolean;
  data: ISelectOptions[];
  selectProps?: ISelectProps;
  controllerProps: UseControllerProps;
  activeInActiveTag?: boolean;
  handleOnChange?: (id: number) => void;
  displayKey?: 'name' | 'description';
}

const FormControlSelect: React.FC<IFormControlSelect> = ({
  methods,
  label,
  isLoading,
  data,
  selectProps,
  controllerProps,
  activeInActiveTag,
  handleOnChange,
  displayKey = 'name',
}) => {
  const {
    formState: { errors },
    control,
  } = methods;
  const { name } = controllerProps;

  return (
    <>
      <Controller
        control={control}
        {...controllerProps}
        render={({ field: { onChange, value } }) => (
          <div>
            <span>{label}</span>
            <Select
              placeholder={`Select ${label}`}
              onChange={(id) => {
                if (handleOnChange) {
                  handleOnChange(id);
                }
                onChange(id);
              }}
              value={value}
              invalid={!!errors[name]}
              loading={isLoading}
              optionFilterProp='description'
              {...selectProps}
              data-testid={name}
            >
              {data.map((item) => (
                <Option
                  key={`${item.id}_${item[displayKey]}`}
                  value={item.id}
                  description={item[displayKey]}
                  data-testid={`option_${item.name}`}
                >
                  <div className='option-wrapper'>
                    <span> {item[displayKey]}</span>
                    {activeInActiveTag && (
                      <Badge
                        className='status-badge'
                        size={Sizes.Small}
                        sentiment={`${item.isActive ? 'positive' : 'negative'}`}
                      >
                        {item.isActive ? 'Active' : 'Inactive'}
                      </Badge>
                    )}
                  </div>
                </Option>
              ))}
            </Select>
          </div>
        )}
      />
      {errors[name]?.message && (
        <ErrorMessage>{String(errors[name]?.message)}</ErrorMessage>
      )}
    </>
  );
};
export default FormControlSelect;
